module.exports = __webpack_public_path__ + "static/img/Robb_Bank$.2da4276.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/card/Robb_Bank$.jpg
// module id = E+H2
// module chunks = 1